export const translationFeature = 'dialogMixinTranslations';
